import React, { Component, Fragment } from "react";
import {
  showNotification, Filter, TextInput, SimpleForm, List, Edit, Query,
  Create, Datagrid, SelectInput, FormTab, EditButton, DateField, FunctionField,
  NumberField, Button, Link, Toolbar, TextField, Pagination, SaveButton,
  ReferenceInput, AutocompleteInput, ReferenceField, ReferenceManyField,
  NumberInput, DateInput, LongTextInput, FormDataConsumer, TabbedForm 
} from 'react-admin';
import { GenericInputFilter } from '../components/selectboxfilter/genericInputFilter';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { parse } from "query-string";
import dataProviderFactory from '../dataProvider'
import { GET_LIST, UPDATE } from 'react-admin'
import moment from "moment";
import { isNil, head, filter, path, propEq, prop, sum, map, ifElse } from 'ramda'
import RefundButtonDamage from "../components/RefundButtonDamage";
import { getPermissionRole } from "../util";

const chargeTypes = [
  { _id: '1', description: 'Stripe' },
  { _id: '2', description: 'Other (Money, bank transfer)' },
];

const InfoField = (props) => {
  const { text } = props
  return (
    <React.Fragment>
      {text}
    </React.Fragment>
  )
};

const ChargeTypeId = (props) => {
  const { client, rentalId } = props

  const getStripeType = (rental) => {
    return rental.location_id_1 === 3
      ? "rentals_pt"
      : "rentals";
  }

  const isUserStripe = (rental, client) => {
    let stripToUse = null;
    if (!isNil(rental)) {
      const stripeType = getStripeType(rental);
      stripToUse = prop(`stripe_${stripeType}`, client);
    }
    return !isNil(stripToUse);
  };

  const rental = head(filter(propEq("id", parseInt(rentalId, 0)), client.rentals));

  let stripeUser = false;
  if (!isNil(rental)) {
    stripeUser = isUserStripe(rental, client);
  }

  return (
    <React.Fragment>
      <h4>Charge Customer</h4>
      <SelectInput source="charge_type_id" choices={chargeTypes} optionText="description"
        disabled={!stripeUser}
        optionValue="_id" defaultValue={'2'} />
      <LongTextInput source="comments" label="Invoice comments" />
    </React.Fragment>
  )
};

const VehicleDamagePagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />

class AsyncRentalComponent extends React.Component {

  constructor(props) {
    super(props);
    this.offset = 0
    this.state = { data_rentals: [] }
  }

  async getDataFor(clientId) {
    const dataProvider = await dataProviderFactory('rest')
    const response = await dataProvider(GET_LIST, 'rentals', {
      filter: {
        client_id: clientId,
        show_all: true,
      },
      pagination: {
        page: 1,
        perPage: 999,
      },
      sort: { field: 'date_1', order: 'ASC' },
    })
    return response.data
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.formData.client_id !== prevProps.formData.client_id) {
      this.getDataFor(this.props.formData.client_id).then((dataItems) => {
        const data_rentals = { data_rentals: dataItems }
        if (data_rentals.data_rentals.length === 0) {
          this.props.formData.rental_id = null
        }
        this.props.formData.vehicle_id = null
        this.setState(data_rentals)
      })
    }
  }

  async componentDidMount() {
    if (this.props.formData.client_id) {
      let defaultItemId = this.props.formData.client_id
      const dataItems = await this.getDataFor(defaultItemId)
      const data_rentals = { data_rentals: dataItems }
      if (data_rentals.data_rentals.length === 0) {
        this.props.formData.rental_id = null
      }
      this.setState(data_rentals)
      this.setState({ data: [] })
    }
  }
  render() {
    if (this.state.data_rentals.length > 0) {
      return (
        <SelectInput
          source="rental_id"
          choices={this.state.data_rentals}
          optionText={
            rental => {
              return (
                rental.type === 1 ? `${rental.rental_status} Tour - ${rental.booking.tour.tour_name.tour_name_en} - (${rental.date_1} to ${rental.date_2})` : `Rental ${rental.date_1} to ${rental.date_2}`
              )
            }
          }
        />
      )
    }
    return (
      <React.Fragment></React.Fragment>
    )
  }
}

class AsyncVehicleComponent extends React.Component {

  constructor(props) {
    super(props);
    this.offset = 0
    this.state = { data: [] }
  }

  async getDataFor(rentalId) {
    const dataProvider = await dataProviderFactory('rest')
    const response = await dataProvider(GET_LIST, 'vehicles', {
      filter: {
        from: '',
        to: '',
        rental_id: rentalId
      },
      pagination: {
        page: 1,
        perPage: 999,
      },
      sort: { field: 'licence_plate', order: 'ASC' },
    })
    return response.data
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.formData.rental_id !== prevProps.formData.rental_id) {
      this.getDataFor(this.props.formData.rental_id).then((dataItems) => {
        const data = { data: dataItems }
        this.setState(data)
      })
    }
  }

  async componentDidMount() {
    if (this.props.formData.rental_id) {
      let defaultItemId = this.props.formData.rental_id
      const dataItems = await this.getDataFor(defaultItemId)
      const data = { data: dataItems }
      this.setState(data)
    }
  }
  render() {
    if (this.props.formData.rental_id !== undefined && this.state.data.length > 0) {
      return (
        <SelectInput
          source="vehicle_id"
          choices={this.state.data}
          optionText={vehicle => {
            return (
              vehicle.model !== undefined ? `${vehicle.licence_plate} ${vehicle.renting ? "®" : ""} - (${vehicle.model.model_name})` : `${vehicle.licence_plate} ${vehicle.renting ? "®" : ""}`
            )
          }
          }
        />
      )
    }
    return (
      <React.Fragment></React.Fragment>
    )
  }
}

const VehicleDamageFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    <TextInput label="Licence Plate" source="licence_plate" alwaysOn />
    <GenericInputFilter label="Repair Place" source="location_id" search_resource="locations" resource_field="location_name" resource_id="location_id" alwaysOn />
  </Filter>
);

const validateForm = (values) => {
  const errors = {};
  if (!values.client_id) {
    errors.client_id = ["Client is required"];
  }
  if (!values.rental_id) {
    errors.rental_id = ["Rental is required"];
  }
  if (!values.location_id) {
    errors.location_id = ['Repair Place is required'];
  }
  if (!values.km) {
    errors.km = ['Kms is required'];
  }
  if (!values.cost) {
    errors.cost = ['Cost is required'];
  }
  if (!values.ammount_charged) {
    let monto = parseFloat(values.ammount_charged)
    if( monto < 0 )
      errors.ammount_charged = ['Amount charged  is required'];
  }
  if (!values.damage_date) {
    errors.damage_date = ['Repair date is required'];
  }
  if (!values.charge_type_id) {
    errors.charge_type_id = ['Charge Type is required'];
  }
  if (isNil(values.comments) && values.charge_type_id !== '1') {
    errors.comments = ['Please add comment'];
  }
  return errors
};

const CancelButton = (_props) => {
  return (
    <Button
      component={Link}
      to={{
        pathname: `${_props.redirectTo}`
      }}
      label="Back">
      <ArrowBackIcon />
    </Button>
  )
}

export const VehicleDamageList = (props) => (

  <List {...props} resource="vehicle_damages" pagination={<VehicleDamagePagination />} bulkActionButtons={false} filters={<VehicleDamageFilter />} sort={{ field: 'damage_date', order: 'DESC' }}>
    <Datagrid>
      <TextField label="ID" source="id" />
      <TextField label="Licence Plate" source="vehicle.licence_plate" sortable={false} />
      <TextField label="Repair Place" source="location.location_name" sortable={false} />
      <DateField source="damage_date" />
      <NumberField source="cost" options={{ style: 'currency', currency: 'EUR' }} label="Cost" />
      <NumberField source="ammount_charged" options={{ style: 'currency', currency: 'EUR' }} label="Charged" />
      <TextField source="km" label="KM" />
      <EditButton />
    </Datagrid>
  </List>
);

const DamageToolbar = (props) => {
  return (
    <Toolbar {...props}  >
      {([1, 2, 3, 4, 6, 9].includes(getPermissionRole()) && 
        <SaveButton redirect={props.redirectOption} />
      )}
      {/* <DeleteButton record={props.record} resource={props.resource} redirect={ `/vehicles/${props.record.vehicle_id}/6`} /> */}
      <CancelButton redirectTo={props.redirect} />
    </Toolbar>
  )
}

const DamageCreateToolbar = (props) => {
  return (
    <Toolbar {...props}  >
      {([1, 2, 3, 4, 6, 9].includes(getPermissionRole()) && 
        <SaveButton redirect={props.redirectOption} />
      )}
    </Toolbar>
  )
}

const VehicleDamageTitleCreate = (object) => (
  <span>
    {' Create Vehicle Damage '}
  </span>
);

const VehicleDamageTitle = (object) => (
  <span>
    {' Edit Vehicle Damage '} &quot;{
      `${object.record.id}`
    }&quot;
  </span>
);

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}


export const VehicleDamageEdit = ({ classes, ...props }) => {
  const vehicle_id = parse(props.location.search).vehicle_id
  const client_id = parse(props.location.search).client_id
  const redirect = vehicle_id ? `/vehicles/${vehicle_id}/6` : (client_id ? `/clients/${client_id}` : '/vehicle_damages')

  return (
    <Edit title={<VehicleDamageTitle />} {...props}>
      <TabbedForm toolbar={<DamageToolbar redirectOption={redirect} />} redirect={redirect} >
        <FormTab label="Damage">
          <ReferenceField label="Customer" source="rental.booking_id" linkType={false} reference="bookings" perPage={100} >
            <FunctionField render={booking => {
              return `${booking.r_first_name} ${booking.r_last_name}`
            }} />
          </ReferenceField>
          <ReferenceField label="Rental" source="rental_id" reference="rentals" linkType={false}>
            <FunctionField render={rental => {
              return <InfoField text={rental.type === '1' ? `Tour - ${rental.booking.tour.tour_name.tour_name_en} - (${rental.date_1} to ${rental.date_2})` : `Rental ${rental.date_1} to ${rental.date_2}`} />
            }} />
          </ReferenceField>
          <ReferenceField label="Vehicle" source="vehicle_id" linkType={false} reference="vehicles" filter={{ only_bases: 'false' }}>
            <FunctionField render={vehicle => {
              return `${vehicle.licence_plate} ${vehicle.renting ? "®" : ""}`
            }} />
          </ReferenceField>
          <ReferenceInput label="Repair Place" source="location_id" reference="locations" filter={{ only_bases: 'false' }} sort={{ field: 'location_name', order: 'ASC' }}>
            <AutocompleteInput
              optionText={location =>
                `${location.location_name}`
              }
            />
          </ReferenceInput>
          {/* <BooleanInput source="p4m" label="P4M" /> */}
          <NumberInput source="km" label="Kms" />
          <NumberField source="cost" label="Cost" />
          <NumberField source="ammount_charged" label="Amount Charged (EUR)" />
          <DateInput label="Repair date" source="damage_date" locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha} />
          <LongTextInput source="comment" label="Comments" />
        </FormTab>
        <FormTab label="Charges">
          <ReferenceManyField
            label="Charges"
            reference="charges"
            target="damage_id"
            filter={{ type: 'damage' }}
          >
            <Datagrid>
              <DateField source="date" />
              <NumberField
                source="value"
                options={{ style: "currency", currency: "EUR" }}
              />
              <NumberField
                source="refunded_value"
                options={{ style: "currency", currency: "EUR" }}
              />
              <TextField source="token" />
              <TextField source="stripe_status" />
              <TextField source="stripe_error" label="Stripe last error" />
              <TextField source="comments" />
              <FunctionField
                label="Status"
                render={charge => {
                  return ` ${charge.status ? "Paid" : "Not Paid"}`;
                }}
              />
              <FunctionField
                label="Type"
                render={charge => {
                  return ` ${charge.charge_type === 1 ? "Stripe" : "Money / Bank / Other"
                    }`;
                }}
              />
              <TextField source="express_invoice_status" label="IE Status" />
              <TextField source="invoice_express_error" label="IE Last Error" />
              <FunctionField
                label="Invoice Url"
                render={charge => {
                  if (charge.express_invoice_url) {
                    return (
                      <a target="_blank" href={charge.express_invoice_url}>
                        Invoice - {charge.express_invoice_id}{" "}
                      </a>
                    );
                  } else {
                    return <p />;
                  }
                }}
              />
              <FunctionField
                render={charge => {
                  if (charge.status && !charge.to_refund && [1, 2, 6].includes(getPermissionRole())) {
                    return <RefundButtonDamage record={charge} history={props} />;
                  }
                  return "";
                }}
              />
            </Datagrid>
          </ReferenceManyField>
        </FormTab>
      </TabbedForm>
    </Edit>
  )
};

export const VehicleDamageCreate = ({ classes, ...props }) => {
  const p = props
  const redirect = p.location.state
  let link = '/vehicles'
  if (redirect != null) {
    link = `/${redirect.miga}`
  } 

    return (
      <Create title={<VehicleDamageTitleCreate />} {...props}>
        <SimpleForm validate={validateForm} redirect={link} toolbar={<DamageCreateToolbar redirectOption={redirect} />}>
          {props.location.search !== '' &&
            <ReferenceField label="Customer" source="client_id" reference="clients" linkType={false} >
              <FunctionField render={client => {
                return `${client.client_first_name} ${client.client_last_name}`
              }} />
            </ReferenceField>
          }

          {props.location.search === '' &&
            <ReferenceInput label="Customer" source="client_id" reference="clients" perPage={100} sort={{ field: 'client_first_name', order: 'ASC' }} >
              <AutocompleteInput
                optionText={client =>
                  `${client.client_first_name} ${client.client_last_name}`
                }
              />
            </ReferenceInput>
          }

          {props.location.search === '' &&
            <FormDataConsumer>
              {({ formData, rest, ...props }) => {
                if (formData.client_id !== undefined) {
                  return (
                    <AsyncRentalComponent formData={formData} rest={rest} />
                  )
                }
                return (
                  <React.Fragment>
                  </React.Fragment>
                )
              }
              }
            </FormDataConsumer>
          }

          {props.location.search === '' &&
            <FormDataConsumer>
              {({ formData, rest, ...props }) => {
                if (formData.rental_id !== undefined) {
                  return (
                    <AsyncVehicleComponent formData={formData} rest={rest} />
                  )
                }
                return (
                  <React.Fragment>
                  </React.Fragment>
                )
              }
              }
            </FormDataConsumer>
          }

          <ReferenceInput label="Repair Place" source="location_id" reference="locations" filter={{ only_bases: 'false' }} sort={{ field: 'location_name', order: 'ASC' }}>
            <AutocompleteInput
              optionText={location =>
                `${location.location_name}`
              }
            />
          </ReferenceInput>
          {/* <BooleanInput source="p4m" label="P4M" /> */}
          <NumberInput source="km" label="Kms" />
          <NumberInput source="cost" label="Cost" />
          <NumberInput source="ammount_charged" defaultValue={'0'} label="Amount Charged" />
          <DateInput label="Repair date" source="damage_date" locales="es-Es" options={{ timeZone: 'UTC' }} />
          <LongTextInput source="comment" label="Comments" />
          <FormDataConsumer>
            {({ formData, rest, ...props }) => {
              if (formData.client_id !== undefined) {
                console.log(formData.client_id)
                if(formData.client_id !== '74'){
                return (
                  <Query type="GET_ONE" resource="clients" payload={{ id: formData.client_id }}>
                    {({ data, loading }) => loading ? '' : <ChargeTypeId client={data} rest={rest} rentalId={formData.rental_id} />
                    }
                  </Query>
                )}
              }
              return (
                <React.Fragment></React.Fragment>
              )
            }
            }
          </FormDataConsumer>
        </SimpleForm>
      </Create>
    )    


};


// WEBPACK FOOTER //
// ./src/resources/vehicleDamages.js